import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "本当に削除してよろしいですか？", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("削除")

import {
    withDefaults
  } from 'vue'
  import { Project } from '@/types/project'

  interface Props {
    modelValue?: boolean;
    deleteProject: Project;
  }
  interface Emits {
    (e: "submit", project: Project): void;
    (e: "update:model-value", value: boolean): void;
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { type: Boolean, required: false, default: false },
    deleteProject: { type: null, required: true }
  },
  emits: ["submit", "update:model-value"],
  setup(__props: any, { emit }: { emit: ({
    (e: "submit", project: Project): void;
    (e: "update:model-value", value: boolean): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: boolean, deleteProject: Project }
  

  

  const handleSubmit = (): void => {
    emit('submit', props.deleteProject);
  }
  const handleClosed = (): void => {
    emit('update:model-value', false);
  }

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.modelValue,
    onClosed: handleClosed,
    title: "削除確認",
    width: "30%"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: handleSubmit
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})